exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckboxListItem{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:8px;font-size:14px;color:var(--text-primary)}.CheckboxListItem input[type=checkbox]{height:18px;margin:0;width:18px}.CheckboxListItem a{color:var(--action-primary)}.CheckboxListItem-ImageContainer{width:25px;height:25px;margin:0px 8px;background-size:contain;background-repeat:no-repeat;background-position:center}", ""]);

// exports
